import styled from '@emotion/styled'
import { colors } from '../../../../__styling/settings/colors'
import { calcRem } from '../../../../__styling/style-functions/calc-rem'
import { visuallyhidden } from '../../../../__styling/style-mixins'

const border = `2px solid ${colors.thewest.greyErmine}`
export const StyledCallToAction = styled('aside')(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginTop: calcRem(theme.margins.lg),
    marginBottom: calcRem(theme.margins.lg),
    borderTop: border,
    borderBottom: border,
    textAlign: 'center',
}))

const saveImageSize = 50

export const StyledSaveIcon = styled('img')(({ theme }) => ({
    position: 'absolute',
    width: calcRem(saveImageSize),
    left: calcRem((50 + theme.margins.sm) * -1),
    top: calcRem(-5),
}))

export const StyledCallToActionDetails = styled('div')(({ theme }) => ({
    position: 'relative',
    margin: calcRem(theme.margins.md, saveImageSize, theme.margins.sm),
}))

export const StyledCallToActionTitle = styled('p')({
    margin: 0,
    fontSize: calcRem(18),
    fontWeight: 700,
})

export const StyledCallToActionSubtitle = styled('p')(({ theme }) => ({
    margin: 0,
    fontFamily: theme.fonts.sansSerifCond,
    fontSize: calcRem(13),
}))

export const StyledCallToActionSubtitleText = styled('span')<{
    bold?: boolean
    strikethrough?: boolean
}>(({ bold, strikethrough }) => ({
    fontWeight: bold ? 700 : undefined,
    textDecoration: strikethrough ? 'line-through' : undefined,
}))

export const StyledCallToActionDescription = styled('div')(({ theme }) => ({
    marginBottom: theme.margins.sm,
}))

export const StyledCallToActionDescriptionText = styled('p')({
    margin: 0,
    fontSize: calcRem(14),
})

export const StyledPlusImage = styled('img')({
    display: 'inline-block',
    width: calcRem(40),
    marginBottom: calcRem(-5),
})

export const StyledSubscribeButton = styled('button')(({ theme }) => ({
    padding: calcRem(theme.margins.md),
    marginBottom: calcRem(theme.margins.lg),
    borderRadius: calcRem(2),
    border: 0,
    backgroundImage: `linear-gradient(180deg, #2b6ee9 0%, ${colors.thewest.westblue} 66%)`,
    color: colors.white,
    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(11),
    fontWeight: 700,
    textDecoration: 'none',
    textTransform: 'uppercase',
    cursor: 'pointer',

    '&:hover, &:focus': {
        backgroundImage: 'none',
        outline: 'none',
    },

    '&:hover': {
        backgroundColor: colors.thewest.greyGorilla,
    },

    '&:focus': {
        backgroundColor: colors.thewest.greyGorilla,
        textDecoration: 'underline',
    },
}))

export const StyledSubscriberLogin = styled('div')({
    position: 'absolute',
    alignSelf: 'center',
    bottom: calcRem(-11),
    padding: '2px',
    backgroundColor: colors.white,
    fontSize: calcRem(11),
})

export const StyledTAndCs = styled('div')(({ theme }) => ({
    position: 'absolute',
    right: 0,
    bottom: 0,
    fontFamily: theme.fonts.sansSerifCond,
    fontSize: calcRem(11),
    fontWeight: 700,
}))

export const StyledHiddenSpans = styled('span')(visuallyhidden)
